import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, model, signal, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { Dialog } from '../../../../@core/services/modal/modal.interfaces';
import { ChangeStatusOfDocumentLineItemResult, DocumentLineItem, DocumentStatusType } from '../../../../generated/generated-types';
import { GenericEnumDropDownComponent } from '../../../../shared/controls/generic-enum-drop-down/generic-enum-drop-down.component';
import { DocumentLineItemService } from '../../services/document-line-item.service';
import { WidgetDocumentStatusIconComponent } from '../widget-document-status-icon/widget-document-status-icon.component';

@Component({
  selector: 'app-widget-edit-dli-status',
  imports: [
    CommonModule,
    FormsModule,
    TranslatePipe,
    WidgetDocumentStatusIconComponent,
    GenericEnumDropDownComponent,
    ButtonModule,
  ],
  templateUrl: './widget-edit-dli-status.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WidgetEditDliStatusComponent implements Dialog<ChangeStatusOfDocumentLineItemResult> {

  resolveWith: (result?: ChangeStatusOfDocumentLineItemResult) => void;

  documentLineItem = model<DocumentLineItem>(null);

  newStatus = signal<DocumentStatusType>(null);

  btnIsDisabled = computed(() => {
    if (!this.documentLineItem() || !this.newStatus() || this.documentLineItem().status === this.newStatus()) {
      return true;
    }
    return false;
  });

  dliService = inject(DocumentLineItemService);

  confirm() {
    this.dliService.changeStatusOfDocumentLineItem(this.documentLineItem().id, this.newStatus())
      .then((result) => {
        if (result && result.documentLineItem?.status) {
          this.documentLineItem().status = result.documentLineItem?.status;
          this.resolveWith(result);
        }
      });
  }
}
